module.exports = __webpack_public_path__ + "no.svg?ee5eab3de0a8e3942321e7cd896d788b";